// extracted by mini-css-extract-plugin
module.exports = {"role":"role-P5bo9","role_editor":"role_editor-NmWED","hover_effect":"hover_effect-d1Xyx","inner":"inner-EUeRP","role_viewer":"role_viewer-J4izU","opened":"opened-skUc3"};